import angular from 'angular';
import AuthRoutingModule from './auth-routing-module';
import ResetAccountPasswordModule from './components/reset-account-password/reset-account-password-module';
import ForgotPasswordModule from './components/forgot-password/forgot-password-module';
import TwoFactorModule from './components/two-factor/two-factor-module';
import './config/errorcodes.conf';
import './components/forgot-username/forgot-username-component';
import './components/change-password/change-password-component';
import './components/login-form/login-form-component';

export default angular.module('auth', [
  AuthRoutingModule.name,
  ResetAccountPasswordModule.name,
  ForgotPasswordModule.name,
  TwoFactorModule.name,
  'auth-errorcodes',
  'forgot-password',
  'forgot-username',
  'security',
  'change-password',
  'user',
  'login-form',
]);



// WEBPACK FOOTER //
// ./src/modules/auth/auth-module.js